var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "modal fade",
      attrs: {
        id: "upload-evidence-image-modal",
        "data-backdrop": "static",
        "data-keyboard": "false",
        role: "dialog"
      }
    },
    [
      _c(
        "div",
        {
          staticClass: "modal-dialog modal-md",
          on: {
            click: function($event) {
              $event.stopPropagation()
            }
          }
        },
        [
          _c("div", { staticClass: "modal-content" }, [
            _c("div", { staticClass: "modal-body" }, [
              _c("div", { staticClass: "flexbox" }, [
                _c(
                  "div",
                  { staticClass: "col-sm-12" },
                  [
                    _c("evidence-image-input", {
                      attrs: { option: this.option },
                      on: {
                        close: function($event) {
                          _vm.$emit("close")
                        },
                        handleSuccess: function($event) {
                          _vm.$emit("handleSuccess")
                        }
                      }
                    })
                  ],
                  1
                )
              ])
            ])
          ])
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-8dd8b55a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8dd8b55a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/view/warehouseAmazon/UploadEvidenceImageModal.vue
// module id = null
// module chunks = 